module.exports = __webpack_public_path__ + "01.a65cc1b0.png";